'use strict';

angular.module('shiftTraderApp').controller('ManageNotificationsCtrl', function(
  params, allDepartments, subs, $timeout, $uibModalInstance, UserCommunicationSubscriptions, Session
) {
  var vm = this

  vm.me = params.me
  vm.user = params.user
  vm.allDepartments = allDepartments
  vm.allDepartments.push({
    id: -1,
    name: 'Uncategorized'
  })

  vm.userCommSubs = lodash.map(subs, function (sub) {
    if (sub.rules && sub.rules.departments && (lodash.indexOf(sub.rules.departments,  null) >= 0)) {
      var idx = lodash.indexOf(sub.rules.departments, null);
      sub.rules.departments[idx] = -1;
    }
    return sub
  })

  var initTimeout = $timeout(function () {
    initTimeout = undefined
  }, 200)


  vm.close = $uibModalInstance.close

  vm.subTypes = [],
  vm.subTypeTimeouts = []

  var sub = undefined

  /**
   * Create Daily Manager Digest Subscription
   */
  sub = lodash.find(vm.userCommSubs, { shortType: 'DailyManagerDigest' })
  if (!sub) {
    sub = {
      id: null,
      type: 'UserCommunicationSubscription::DailyManagerDigest',
      sms_enabled: false,
      email_enabled: false,
      organization_id: Session.getCurrentOrgId(),
      user_id: vm.user.id,
      rules: {}
    }
  }

  var dailyManagerDigest = {
    sub: sub,
    shortType: 'DailyManagerDigest',
    name: 'Daily Manager Digest',
    show_sms: false,
    show_email: true,
    show: function() {
      return params.rawPermissions['users.can_receive_daily_digest'];
    }
  }

  if (dailyManagerDigest.show()) {
    vm.subTypes.push(dailyManagerDigest)
    vm.subTypeTimeouts.push(undefined)
  }

  /**
   * Create New Giveaway Subscription
   */
  sub = lodash.find(vm.userCommSubs, { shortType: 'NewGiveawayNotification' })
  if (!sub) {
    sub = {
      id: null,
      type: 'UserCommunicationSubscription::NewGiveawayNotification',
      sms_enabled: false,
      email_enabled: false,
      organization_id: Session.getCurrentOrgId(),
      user_id: vm.user.id,
      rules: {}
    }
  }

  var newGiveawayNotification = {
    sub: _.find(vm.userCommSubs, {shortType: 'NewGiveawayNotification'}),
    shortType: 'NewGiveawayNotification',
    name: 'New Giveaway Notification',
    show_sms: false,
    show_email: true,
    show: function() {
      return true
    }
  }

  if (newGiveawayNotification.show()) {
    vm.subTypes.push(newGiveawayNotification)
    vm.subTypeTimeouts.push(undefined)
  }

  /**
   * Create Manager Trade Subscription
   */
  var managerTradeNotification = {
    sub: undefined,
    shortType: 'ManagerTradeNotification',
    name: 'Manager Trade Notification',
    show_sms: true,
    show_email: false,
    show: function() {
      return params.rawPermissions['trades.can_receive_trade_notif'];
    },
    rules: {},
    showDepartmentSelector: true
  }

  sub = lodash.find(vm.userCommSubs, { shortType: 'ManagerTradeNotification' })
  if (!sub) {
    sub = {
      id: null,
      type: 'UserCommunicationSubscription::ManagerTradeNotification',
      sms_enabled: false,
      email_enabled: false,
      organization_id: Session.getCurrentOrgId(),
      user_id: vm.user.id,
      rules: {}
    }
  } else {
    var selectAllDepartments = (
      lodash.isNull(sub.rules) ||
      lodash.isNull(sub.rules.departments) ||
      sub.rules === {} ||
      sub.rules.departments === []
    )

    managerTradeNotification.selectAllDepartments = selectAllDepartments

    if (!selectAllDepartments) {
      managerTradeNotification.selectedDepartments = lodash.filter(
        lodash.map(sub.rules.departments, function (deptId) {
          var dept = lodash.find(vm.allDepartments, { id: deptId })
          return lodash.isUndefined(dept) ? false : dept
        }), function (dept) {
          return dept
        }
      )
    }
  }

  managerTradeNotification.sub = sub

  if (managerTradeNotification.show()) {
    vm.subTypes.push(managerTradeNotification)
    vm.subTypeTimeouts.push(undefined)
  }




  vm.updateSubType = function (idx) {
    console.log('Updating Sub Type', vm.subTypes[idx])
    if (!initTimeout) {
      $timeout.cancel(vm.subTypeTimeouts[idx])

      if (vm.subTypes[idx].selectAllDepartments) {
        vm.subTypes[idx].sub.rules.departments = null
        vm.subTypes[idx].selectedDepartments = []
      } else {
        if (vm.subTypes[idx].selectedDepartments) {
          vm.subTypes[idx].sub.rules = { departments: null }
          vm.subTypes[idx].sub.rules.departments = lodash.map(vm.subTypes[idx].selectedDepartments, 'id')
        }
      }

      vm.subTypeTimeouts[idx] = $timeout(function () {
        if (vm.subTypes[idx].sub.id) {
          vm.subTypes[idx].sub.$update({
            sms_enabled: vm.subTypes[idx].sub.sms_enabled,
            email_enabled: vm.subTypes[idx].sub.email_enabled,
            rules: vm.subTypes[idx].sub.rules
          })
        } else {
          UserCommunicationSubscriptions.create(vm.subTypes[idx].sub)
            .then(function (data) {
              vm.subTypes[idx].sub = data
            })
        }
      }, 400)
    }
  }
})
